import styled from "styled-components";
import { TOPBAR_H } from "../../config/layout";

export const Container = styled.div`
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: ${TOPBAR_H} 0 60px;
`;

export const Content = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 34px 16px 0;
`;

export const PageTitle = styled.h1`
  color: #1b6b78;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 26px;
`;

export const Card = styled.form`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.07);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

export const SectionTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 -8px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;
  align-items: start;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 0.88rem;
  color: #333;
`;

const control = `
  padding: 11px 13px;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #222;
  outline: none;
  background: #fff;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
`;

export const Input = styled.input`
  ${control}
  border: 1px solid ${({ $error }) => ($error ? "#e05c5c" : "#dfe6ec")};

  &:focus { border-color: ${({ $error }) => ($error ? "#e05c5c" : "#26A9B6")}; }
  &::placeholder { color: #b7c1c9; }
`;

export const Textarea = styled.textarea`
  ${control}
  border: 1px solid #dfe6ec;
  min-height: 84px;
  resize: vertical;

  &:focus { border-color: #26A9B6; }
  &::placeholder { color: #b7c1c9; }
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.35;
  color: ${({ $error }) => ($error ? "#e05c5c" : "#9aa7b2")};
`;

export const SubmitButton = styled.button`
  padding: 13px 20px;
  border-radius: 7px;
  border: none;
  background: ${({ disabled }) => (disabled ? "#8b8b8b" : "#1b6b78")};
  color: #fff;
  font-size: 0.95rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:hover { background: ${({ disabled }) => (disabled ? "#8b8b8b" : "#175a65")}; }
`;

export const LinkText = styled.p`
  margin: 18px 0 0;
  text-align: center;
  font-size: 0.85rem;
  color: #555;

  a { color: #26A9B6; font-weight: 600; text-decoration: none; }
  a:hover { text-decoration: underline; }
`;
